import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Spinner from '../../../Plateforme/Atoms/Spinner';
import { supabase } from '../../../lib/supabaseClient';
import * as api from '../../../api';
import { generateFD100KVDataURL } from '../../Utils/generateFD100KV';
import { getEventDesignerDisplayName } from '../../../Components/AdminPanels/utils/eventDesignerHelpers';

const Container = styled.div`
    max-width: 1600px;
    margin: 0 auto;
    padding: 20px;
`;

const PageTitle = styled.h1`
    text-align: center;
    font-size: 32px;
    font-weight: 800;
    margin: 40px 0 10px 0;
`;

const Subtitle = styled.p`
    text-align: center;
    color: #666;
    margin-bottom: 30px;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
    gap: 24px;
`;

const Card = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 20px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .name {
        font-weight: 700;
        font-size: 16px;
        color: #333;
    }

    .partenaire {
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        padding: 2px 8px;
        border-radius: 4px;
        background: #e3f2fd;
        color: #1976d2;
    }

    .base {
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        padding: 2px 8px;
        border-radius: 4px;
        background: #f3e5f5;
        color: #7b1fa2;
    }

    .base-live {
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        padding: 2px 8px;
        border-radius: 4px;
        background: #fff3e0;
        color: #e65100;
    }
`;

const KVRow = styled.div`
    display: flex;
    gap: 16px;
`;

const KVBox = styled.div`
    flex: 1;
    text-align: center;

    .label {
        font-size: 11px;
        font-weight: 700;
        color: #999;
        text-transform: uppercase;
        margin-bottom: 6px;
        letter-spacing: 0.5px;
    }

    img {
        width: 100%;
        border-radius: 6px;
        border: 1px solid #eee;
    }
`;

const EVENT_ID = '67590da5499bcc995c210b40';

const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc',
    '67a0b8331b103d938bafa954',
    '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c',
    '67e6c18043d5609350e381a8',
    '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73',
    '67bf2330b1ba28c3144af8d2',
    '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63',
    '67c6b416db48cb16a13c73c7',
    '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c',
    '67d15108d95ccf24eaf191df',
    '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e',
    '662adc507159e5b1b1da7c75',
    '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2',
    '682b5c5f754f51df2ef93bbc',
    '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb',
    '67daebf343d5609350e27a9e',
    '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360',
    '67e1452a43d5609350e2b066',
    '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97',
    '67e3e1cb43d5609350e304e5',
    '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a',
    '67e42d7043d5609350e32539',
    '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0',
    '67e529f743d5609350e33a8c',
    '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f',
    '67e5764d43d5609350e34cb5',
    '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3',
    '67e58da443d5609350e3561d',
    '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905',
    '67e6828d43d5609350e36b6a',
    '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667',
    '67e6c0a843d5609350e380cf',
    '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900',
    '67e7003c43d5609350e38bfc',
    '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae',
    '67f90250a0262e085d37088f',
    '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e',
    '67ab6ade07736060460b3c16',
    '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d',
    '6800b8529167c049fff50e47',
    '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f',
    '6800fad59167c049fff52224',
    '680113739167c049fff52d73',
    '680106139167c049fff525af',
    '680125219167c049fff53405',
    '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e',
    '68020ef79167c049fff54015',
    '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7',
    '680249249167c049fff55a19',
    '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037',
    '680270379167c049fff566f5',
    '680274c09167c049fff567c8',
    '680275419167c049fff567de',
    '68027b389167c049fff56954',
    '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f',
    '6849787b17dde4ca4c4bf043',
    '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4',
    '6808c3f59167c049fff599c7',
    '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee',
    '6801e2f49167c049fff53ce1',
    '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49',
    '6810df4a264e7745556ad75d',
    '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977',
    '680fa9f09167c049fff5e027',
    '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62',
    '6818cac19e656d77bc6c72fa',
    '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0',
    '682d97b2754f51df2ef96070',
    '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

const FD100DefinitiveKVs = () => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [generating, setGenerating] = useState(false);
    const [generationProgress, setGenerationProgress] = useState({ done: 0, total: 0 });
    const [projectNames, setProjectNames] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch frozen KVs
                const { data: kvRows, error } = await supabase
                    .from('fd100_frozen_kvs')
                    .select('project_id, partenaire_name, version, storage_url')
                    .eq('event_id', EVENT_ID)
                    .order('project_id');

                if (error) {
                    console.error('Error fetching frozen KVs:', error);
                    return;
                }

                // Group by project_id + partenaire_name
                const groupMap = {};
                (kvRows || []).forEach(row => {
                    const key = `${row.project_id}__${row.partenaire_name}`;
                    if (!groupMap[key]) {
                        groupMap[key] = {
                            projectId: row.project_id,
                            partenaireName: row.partenaire_name,
                            normalUrl: null,
                            invertedUrl: null,
                            isLiveGenerated: false,
                        };
                    }
                    if (row.version === 'normal') groupMap[key].normalUrl = row.storage_url;
                    if (row.version === 'inverted') groupMap[key].invertedUrl = row.storage_url;
                });

                // Fetch project data from API + tracking table
                const frozenProjectIds = [...new Set((kvRows || []).map(r => r.project_id))];

                const [trackingRes, apiRes] = await Promise.all([
                    supabase
                        .from('fd100_laureats_tracking')
                        .select('project_id, edited_project_name, edited_creator_name')
                        .in('project_id', WINNER_PROJECT_IDS),
                    api.getParticipatingUsersWithData({ eventId: EVENT_ID })
                ]);

                // Build names map and project data map for all winners
                const namesMap = {};
                const projectDataMap = {}; // projectId -> { project, user }
                if (apiRes?.data) {
                    apiRes.data.forEach(user => {
                        if (user.participation?.data?.projets) {
                            user.participation.data.projets.forEach(pid => {
                                const project = user.company?.projects?.find(p => p._id === pid);
                                if (project && WINNER_PROJECT_IDS.includes(project._id)) {
                                    const designerName = project.override_designer_name
                                        || (project.candidate_as_person_fd100_25 === "oui"
                                            ? `${user.hsProfile?.firstname || ''} ${user.hsProfile?.lastname || ''}`.trim()
                                            : user.hsCompany?.properties?.name || '');
                                    namesMap[project._id] = {
                                        projectName: project.name_en?.trim() || project.name?.trim() || '',
                                        creatorName: designerName,
                                    };
                                    projectDataMap[project._id] = { project, user };
                                }
                            });
                        }
                    });
                }

                // Override with definitive names from tracking table
                if (trackingRes?.data) {
                    trackingRes.data.forEach(item => {
                        if (!namesMap[item.project_id]) namesMap[item.project_id] = {};
                        if (item.edited_project_name) namesMap[item.project_id].projectName = item.edited_project_name;
                        if (item.edited_creator_name) namesMap[item.project_id].creatorName = item.edited_creator_name;
                    });
                }
                setProjectNames(namesMap);

                // Find winner projects that have NO frozen _base_ KV
                const projectsWithFrozenBase = new Set(
                    (kvRows || [])
                        .filter(r => r.partenaire_name === '_base_')
                        .map(r => r.project_id)
                );
                const missingBaseIds = WINNER_PROJECT_IDS.filter(
                    id => !projectsWithFrozenBase.has(id) && projectDataMap[id]
                );

                // Live-generate base KVs for those missing
                if (missingBaseIds.length > 0) {
                    setGenerating(true);
                    setGenerationProgress({ done: 0, total: missingBaseIds.length });

                    for (const pid of missingBaseIds) {
                        const pData = projectDataMap[pid];
                        if (!pData) continue;

                        const editedData = namesMap[pid] ? {
                            projectName: namesMap[pid].projectName,
                            creatorName: namesMap[pid].creatorName
                        } : null;

                        try {
                            const normalUrl = await generateFD100KVDataURL(pData, false, 'cover', editedData);
                            const invertedUrl = await generateFD100KVDataURL(pData, true, 'cover', editedData);

                            const key = `${pid}___base_live_`;
                            groupMap[key] = {
                                projectId: pid,
                                partenaireName: '_base_',
                                normalUrl: normalUrl,
                                invertedUrl: invertedUrl,
                                isLiveGenerated: true,
                            };
                        } catch (err) {
                            console.error(`Error generating base KV for ${pid}:`, err);
                        }

                        setGenerationProgress(prev => ({ ...prev, done: prev.done + 1 }));
                    }
                    setGenerating(false);
                }

                setGroups(Object.values(groupMap));
            } catch (err) {
                console.error('Error fetching definitive KVs:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) {
        return (
            <Container>
                <PageTitle>Definitive Key Visuals</PageTitle>
                <div style={{ textAlign: 'center', padding: '60px' }}><Spinner /></div>
            </Container>
        );
    }

    const frozenCount = groups.filter(g => !g.isLiveGenerated).length;
    const liveCount = groups.filter(g => g.isLiveGenerated).length;

    return (
        <Container>
            <PageTitle>FD100 - Definitive Key Visuals</PageTitle>
            <Subtitle>
                {frozenCount} frozen KV pair{frozenCount !== 1 ? 's' : ''}
                {liveCount > 0 && ` + ${liveCount} live-generated base KV${liveCount !== 1 ? 's' : ''}`}
            </Subtitle>

            {generating && (
                <div style={{ textAlign: 'center', padding: '20px', background: '#fff3e0', borderRadius: '8px', marginBottom: '20px' }}>
                    <p style={{ margin: 0, color: '#e65100' }}>
                        Generating missing base KVs... {generationProgress.done} / {generationProgress.total}
                    </p>
                </div>
            )}

            <Grid>
                {groups.map((group, idx) => {
                    const names = projectNames[group.projectId];
                    const displayName = names?.projectName || group.projectId;
                    const creatorName = names?.creatorName || '';

                    return (
                        <Card key={idx}>
                            <CardHeader>
                                <div>
                                    <span className="name">{displayName}</span>
                                    {creatorName && (
                                        <span style={{ marginLeft: 8, color: '#666', fontWeight: 400, fontSize: 14 }}>
                                            {creatorName}
                                        </span>
                                    )}
                                </div>
                                {group.partenaireName && group.partenaireName !== '_base_'
                                    ? <span className="partenaire">{group.partenaireName}</span>
                                    : group.isLiveGenerated
                                        ? <span className="base-live">Base (live)</span>
                                        : <span className="base">Base</span>
                                }
                            </CardHeader>

                            <KVRow>
                                {group.normalUrl && (
                                    <KVBox>
                                        <div className="label">Normal</div>
                                        <img src={group.normalUrl} alt={`${displayName} normal`} />
                                    </KVBox>
                                )}
                                {group.invertedUrl && (
                                    <KVBox>
                                        <div className="label">Inverted</div>
                                        <img src={group.invertedUrl} alt={`${displayName} inverted`} />
                                    </KVBox>
                                )}
                            </KVRow>
                        </Card>
                    );
                })}
            </Grid>
        </Container>
    );
};

export default FD100DefinitiveKVs;
